export default __webpack_public_path__ + "static/media/StemmaIntero.7e7d7bf2.png";